module.exports = __webpack_public_path__ + "img/6f24bf55b91f20202bd7462b49dffd56.png";